import { useQuery } from "@tanstack/react-query";
import api from "../../../../../util/api";
import {
  TransactionApiType,
  PaginatedResponse,
  QueryKeys,
} from "../../../../../util/types";

interface TransactionsFilters {
  status?: string;
  amountFrom?: string;
  amountTo?: string;
  from?: string;
  to?: string;
  completedFrom?: string;
  completedTo?: string;
  reference?: string;
  createdBy?: string;
  paymentProvider?: string;
  isSandbox?: string;
  filter?: string;
  filterValue?: string;
  searchKeyword?: string;
  companyId?: string;
  currency?: string;
  parentEntity?: string;
}

export const useTransactionsList = (
  page = 1,
  limit = 25,
  direction?: string,
  sort = { field: "createdAt", direction: "DESC" },
  filters: TransactionsFilters = {},
  ownerId?: string,
  recurringList?: boolean,
  provider?: string,
  vrpList?: boolean,
  enabled = true
) => {
  const {
    data,
    isLoading,
    isFetching,
    refetch: refreshTransactions,
  } = useQuery<PaginatedResponse<TransactionApiType>>({
    queryKey: [
      QueryKeys.LIST_TRANSACTIONS,
      page,
      limit,
      direction ?? "",
      sort.field,
      sort.direction,
      JSON.stringify(filters),
      ownerId ?? "",
      recurringList ?? false,
      provider ?? "",
      vrpList ?? false,
    ],
    queryFn: async () => {
      const { companyId, ...rest } = filters;
      return await api.getPaginatedTransactions(
        page,
        limit,
        direction,
        { sort: sort.field, sortDirection: sort.direction, ...rest },
        companyId ?? ownerId,
        recurringList,
        provider,
        vrpList
      );
    },
    enabled,
    placeholderData: (prev) => prev,
    refetchOnWindowFocus: false,
  });

  return {
    loading: isLoading || isFetching,
    totalDocs: data?.totalDocs ?? 0,
    refreshTransactions,
    transactionsData: data?.docs ?? [],
  };
};
